import { InitialSrpParams, SrpFilterApiParams } from './hooks/useSrpModel';

// this will filter null value params as well as the city and state params
// being passed to the searchV2 API call
export default function filterSearchParams(
  params: InitialSrpParams | SrpFilterApiParams
): SrpFilterApiParams {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([k, v]) => !(v === null || v === undefined || k === 'city' || k === 'state')
    )
  );
}
